import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";

export class PersonNotification extends BaseBus {
    constructor(busObj: PersonNotification = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
    }

    CID(): any {
        return this.personNotificationId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
    }

    personNotificationId: any;
    personId: any;
    primaryId: any;
    appCode: string;
    notificationType: number;
    insertUserId: any;
    insertDt: Date;
}